<template>
    <div id="app">
        <cis-with-detail
        :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sideBarData"
        ></cis-with-detail>
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
            <global-filter
              ref="filterer"
              :tableOptions="tableOptions"
              :filterOptions="filterOptions"
              :filterChips="filterChips"
              :filterOptionNames="filterOptionNames"
              :isActive="isFilterActive"
              @saveOptions="saveOptions"
              @close="isFilterActive = false"
            />
            <vs-row
              id="panelHeaderRow"
              v-show="!isFilterActive"
              vs-type="flex"
              vs-w="12"
              vs-justify="space-between"
            >
              <vs-col
                id="panel-actions"
                vs-type="flex"
                class="w-auto"
                vs-justify="center"
              >
                <vs-row vs-type="flex" vs-w="12">
                  <vs-col vs-type="flex" vs-w="3.75">
                    <vx-tooltip text="Detaylı Filtereleme" position="top">
                      <vs-button
                        @click="isFilterActive = !isFilterActive"
                        class="panel-action text-warning xlarge-button panel-action-box-shadow"
                        color="transparent"
                        icon-pack="pickicon"
                        icon="icon-pick-filter"
                      >
                      </vs-button>
                    </vx-tooltip>
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col id="filter-chips" vs-type="flex">
                <vs-row
                  vs-type="flex"
                  vs-w="12"
                  vs-justify="center"
                  vs-align="center"
                >
                  <vs-button
                    id="clearFilterButton"
                    v-if="filterChips.length > 0"
                    @click="clearFilter"
                    class="mr-2 bg-white text-danger panel-action-box-shadow"
                    icon-pack="feather"
                    icon="icon-slash"
                    radius
                    color="transparent"
                  />
                  <vs-col
                    vs-type="flex"
                    class="w-auto"
                    v-for="(chip, index) in filterChips"
                    :key="index"
                  >
                    <vs-chip
                      color="white"
                      class="panel-action-box-shadow px-1"
                      @click="removeFilter(chip.col, index)"
                      v-show="chip.value != ''"
                      closable
                    >
                      <vs-row vs-tpye="flex" vs-w="12">
                        <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                          <span class="bold text-xsmaller text-dark">
                            {{ chip.name + " :" }}
                          </span>
                        </vs-col>
                        <vs-col
                          vs-type="flex"
                          class="w-auto ml-1"
                          vs-align="center"
                        >
                          <feather-icon
                            v-if="chip.value === true"
                            icon="CheckIcon"
                            svgClasses="w-4 h-4 text-primary"
                          />
                          <feather-icon
                            v-else-if="chip.value === false"
                            icon="XIcon"
                          />
                          <span
                            v-else
                            class="weight-600 italic text-xsmaller text-primary"
                          >
                            {{ chip.value }}
                          </span>
                        </vs-col>
                      </vs-row>
                    </vs-chip>
                  </vs-col>
                </vs-row>
              </vs-col>

            </vs-row>
          </vs-row>
      <div class="flex justify-center">
        <div class="min-h-screen flex overflow-x-scroll py-12">
            <div class="bg-gray-100 rounded-lg px-3 py-3 column-width rounded mr-4" key="bekliyor" >
                <p class="text-gray-700 font-semibold font-sans tracking-wide text-sm">İletildi</p>
                <draggable :list="waitings"
            :animation="200" ghost-class="ghost-card" group="tasks"
            style="min-height:400px"
            @change="seeChange($event, 0)">
              <!-- Each element from here will be draggable and animated. Note :key is very important here to be unique both for draggable and animations to be smooth & consistent. -->
              <template>
                <div
                v-for="task in waitings"
                :key="task.id"
                @click="handleDoubleClick(task)"
                >
    <div :class=" task.isSeen ? 'mt-3 cursor-move bg-white shadow rounded px-3 pt-3 pb-5 border border-white':
    'mt-3 cursor-move bg-white shadow rounded px-3 pt-3 pb-5 border border-white warning'">
      <div class="flex justify-between">
        <p class="text-gray-700 font-semibold font-sans tracking-wide text-sm">{{task.title}}</p>

        <img
          class="w-6 h-6 rounded-full ml-3"
          src="/img/pickposlogo.jpg"
          alt="Avatar"
        >
      </div>
      <div class="flex mt-4 justify-between items-center">
        <span class="text-sm text-gray-600">
            <vs-chip>
      <vs-avatar icon="home" />
      {{task.branchName}}
    </vs-chip>
            </span>
      </div>
      <div class="flex mt-4 justify-between items-center">

        <span class="text-sm text-gray-600">
            <vs-chip>
      <vs-avatar />
      {{task.userName}}
    </vs-chip>
            </span>
        <vs-row vs-justify="flex-end">
          <span style="font-size: 0.7rem;">
            {{(task.createdText)}}</span>
        </vs-row>
      </div>
    </div>
    </div>
  </template>
              <!-- </transition-group> -->
            </draggable>
            </div>

            <div class="bg-gray-100 rounded-lg px-3 py-3 column-width rounded mr-4" key="devam" >
                <p class="text-gray-700 font-semibold font-sans tracking-wide text-sm">Süreç Başladı</p>
                <draggable :list="continues"
            :animation="200" ghost-class="ghost-card" group="tasks"
            style="min-height:400px"
            @change="seeChange($event, 1)">
              <!-- Each element from here will be draggable and animated. Note :key is very important here to be unique both for draggable and animations to be smooth & consistent. -->
              <template>
                <div @dblclick="handleDoubleClick(task)"
                v-for="task in continues"
                :key="task.id">
                <div :class=" task.isSeen ? 'mt-3 cursor-move bg-white shadow rounded px-3 pt-3 pb-5 border border-white':
    'mt-3 cursor-move bg-white shadow rounded px-3 pt-3 pb-5 border border-white warning'">
      <div class="flex justify-between">
        <p class="text-gray-700 font-semibold font-sans tracking-wide text-sm">{{task.title}}</p>

        <img
          class="w-6 h-6 rounded-full ml-3"
          src="/img/pickposlogo.jpg"
          alt="Avatar"
        >
      </div>
      <div class="flex mt-4 justify-between items-center">
        <span class="text-sm text-gray-600">
            <vs-chip>
      <vs-avatar icon="home" />
      {{task.branchName}}
    </vs-chip>
            </span>
      </div>
      <div class="flex mt-4 justify-between items-center">

        <span class="text-sm text-gray-600">
            <vs-chip>
      <vs-avatar />
      {{task.userName}}
    </vs-chip>
            </span>
        <vs-row vs-justify="flex-end">
          <span style="font-size: 0.7rem;">
            {{(task.createdText)}}</span>
        </vs-row>
      </div>
    </div>
    </div>
  </template>
              <!-- </transition-group> -->
            </draggable>
            </div>

            <div class="bg-gray-100 rounded-lg px-3 py-3 column-width rounded mr-4" key="tamam" >
                <p class="text-gray-700 font-semibold font-sans tracking-wide text-sm">Tamamlandı</p>
                <draggable :list="completed"
            :animation="200" ghost-class="ghost-card" group="tasks"
            style="min-height:400px"
            @change="seeChange($event, 2)">
              <!-- Each element from here will be draggable and animated. Note :key is very important here to be unique both for draggable and animations to be smooth & consistent. -->
              <template>
                <div
                v-for="task in completed" @dblclick="handleDoubleClick(task)"
                :key="task.id">
                <div :class=" task.isSeen ? 'mt-3 cursor-move bg-white shadow rounded px-3 pt-3 pb-5 border border-white':
    'mt-3 cursor-move bg-white shadow rounded px-3 pt-3 pb-5 border border-white warning'">
      <div class="flex justify-between">
        <p class="text-gray-700 font-semibold font-sans tracking-wide text-sm">
      {{task.title}}

           </p>

        <img
          class="w-6 h-6 rounded-full ml-3"
          src="/img/pickposlogo.jpg"
          alt="Avatar"
        >
      </div>
      <div class="flex mt-4 justify-between items-center">
        <span class="text-sm text-gray-600">
            <vs-chip>
      <vs-avatar icon="home" />
      {{task.branchName}}
    </vs-chip>
            </span>
      </div>
      <div class="flex mt-4 justify-between items-center">

        <span class="text-sm text-gray-600">
            <vs-chip>
      <vs-avatar />
      {{task.userName}}
    </vs-chip>
            </span>
        <vs-row vs-justify="flex-end">
          <span style="font-size: 0.7rem;">
            {{(task.createdText)}}</span>
        </vs-row>
      </div>
    </div>
    </div>
  </template>
              <!-- </transition-group> -->
            </draggable>
            </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import draggable from "vuedraggable";
  import { getAllAdmin, changeStatus } from "@/api/UserWant";
  import CisWithDetail from "@/views/pages/Cis/CisWithDetail.vue";
  import GlobalFilter from "../GlobalFilter";
  export default {
    name: "App",
    components: {
      draggable,
      CisWithDetail,
      GlobalFilter
    },
    data() {
      return {
        waitings:[],
        continues:[],
        completed:[],
        addNewDataSidebar: false,
        sideBarData: {},
        isFilterActive: false,
        tableOptions: {},
        filterChips: [],
        filterOptions: [
          "dateRange",
          "branch",
          "personal"
        ],
        filterOptionNames: [
          "Tarih",
          "Şube",
          "Personel"
        ],
      };
    },
    created:function(){
        // getAllAdmin(this.tableOptions).then((res)=>{
        //     if (res && res.status == 200) {
        //         res.data.forEach(item => {
        //     if (item.status === 0) {
        //         this.waitings.push(item);
        //     } else if (item.status === 1) {
        //         this.continues.push(item);
        //     } else if (item.status === 2) {
        //         this.completed.push(item);
        //     }
        // });
        //     }else{
        //         this.$vs.notify({
        //         color: "danger",
        //         title: "Hata : " + res.status,
        //         text: "Hata : " + res.status,
        //       });
        //     }
        // })
    },
    watch:{

        tableOptions: {
        deep: true,
        handler(val) {
          this.$nextTick(() => {
            this.getTasks();
          });
        },
      }
    },
    methods:{
        getTasks(){
            let waitings = [];
            let continues = [];
            let completed = [];
            getAllAdmin(this.tableOptions).then((res)=>{
            if (res && res.status == 200) {
                res.data.forEach(item => {
            if (item.status === 0) {
                waitings.push(item);
            } else if (item.status === 1) {
                continues.push(item);
            } else if (item.status === 2) {
                completed.push(item);
            }
        });
        this.waitings = waitings;
        this.continues = continues;
        this.completed = completed;
            }else{
                this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Hata : " + res.status,
              });
            }
        })
        },
        saveOptions(filterOptions, filterChips) {
        this.isFilterActive = false;
        if (_.isEqual(this.tableOptions, filterOptions)) return;
        this.tableOptions = _.cloneDeep(filterOptions);
        this.filterChips = _.cloneDeep(filterChips);
      },
      clearFilter() {
        this.tableOptions = {
          sortBy: "Created",
          sortDirection: "desc",
          pageIndex: 0,
          pageSize: this.itemsPerPage,
          dateRange: {
            startDate:
              this.$now().getHours() >= 0 && this.$now().getHours() <= 2
                ? this.$preDate()
                : this.$now.date(),
            endDate:
              this.$now().getHours() >= 0 && this.$now().getHours() <= 2
                ? this.$preDate()
                : this.$now.date(),
          },
          timeRange: {
            startTime: null,
            endTime: null,
          },
          paymentMethod: null,
          extra: null,
          product: null,
          personal: null,
          order: null,
          price: {
            min: null,
            max: null,
          },
          branch: this.$currentUser.branch,
          dayReportType:null
        };
        this.filterChips.length = 0;
      },
      removeFilter(col, index) {
        //if (col === "branch") this.tableOptions[col] = this.$currentUser.branch;
         this.tableOptions[col] = null;
        this.filterChips.splice(index, 1);
      },
        toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
        handleDoubleClick(task) {
            this.sideBarData = task;
      this.toggleDataSidebar(true)
      task.isSeen = true;
    // Çift tıklama olayı için gerçekleştirilecek işlemler
    // Diğer işlemler...
  },
        seeChange(event, col) {
            if (event.added) {
                let newStatus = {
                    status: col,
                    userWantId: event.added.element.id
                }
                changeStatus(newStatus).then((res)=>{
            if (res && res.status == 200) {
            }else{
                this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Hata : " + res.status,
              });
            }
        })
            }

  }
    }
  };
  </script>

  <style scoped>
  .column-width {
    min-width: 320px;
    width: 320px;
  }
  /* Unfortunately @apply cannot be setup in codesandbox,
  but you'd use "@apply border opacity-50 border-blue-500 bg-gray-200" here */
  .ghost-card {
    opacity: 0.5;
    background: #F7FAFC;
    border: 1px solid #4299e1;
  }

  .warning {
  animation: blinker 1s linear infinite;
  color: red;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
  </style>
